import { postData } from './http';

const googlebot: boolean = /googlebot/i.test(navigator.userAgent);
const prerender:boolean = /prerender/i.test(navigator.userAgent);

function baseLogger(level: string, message: any): Promise<any> {
    if (googlebot || prerender) {
        return Promise.resolve(false);
    }

    const req = {
        LogLevel: level,
        Message: message
    };

    return postData('website/logging/log', req, { logErrors: false });
}

export function logFatal(message) {
    return baseLogger('Fatal', message);
}

export function logError(message) {
    return baseLogger('Error', message);
}

export function logWarn(message) {
    return baseLogger('Warn', message);
}

export function logInfo(message) {
    return baseLogger('Info', message);
}

export function logDebug(message) {
    return baseLogger('Debug', message);
}
